import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	GammaPetitionDetailsPageDecisionMakers,
	type GammaPetitionDetailsPageDecisionMakersQuery,
	type GammaPetitionDetailsPageDecisionMakersQueryVariables,
} from './decisionMakers.graphql';

type DecisionMakerEdge = NonNullable<
	GammaPetitionDetailsPageDecisionMakersQuery['petition']
>['decisionMakersConnection']['edges'][0];

export type DecisionMakers = ReadonlyArray<
	DecisionMakerEdge['node'] & {
		// this was done to avoid having to change the page's code
		// FIXME use the edge in the code instead of doing this mapping
		targetPetitionAssociationData: DecisionMakerEdge['associationData'];
	}
>;

export type DecisionMaker = DecisionMakers[0];

export async function getDecisionMakers(
	petitionSlugOrId: string,
	numDecisionMakers: number,
	utilityContext: UtilityContext,
): Promise<DecisionMakers> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<
		GammaPetitionDetailsPageDecisionMakersQuery,
		GammaPetitionDetailsPageDecisionMakersQueryVariables
	>({
		query: GammaPetitionDetailsPageDecisionMakers,
		variables: {
			slugOrId: petitionSlugOrId,
			numDecisionMakers,
		},
		rejectOnError: false,
	});

	if (!data?.petition?.decisionMakersConnection) throw new Error('Unable to fetch decision makers');

	return data.petition.decisionMakersConnection.edges.map((edge) => ({
		...edge.node,
		targetPetitionAssociationData: edge.associationData,
	}));
}
